import { render } from "./App.vue?vue&type=template&id=dad965bc"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=dad965bc&lang=css"

import exportComponent from "D:\\software\\phpstudy_pro\\WWW\\front-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__